




































import { Component, Vue, Prop } from 'vue-property-decorator';
import VueError from '@/components/VueError.vue';
import GroupAccessItem from '@/components/access/GroupAccessItem.vue';
import { Info } from '@/types/core';

@Component({
  components: {
    VueError,
    GroupAccessItem
  },
})
export default class GroupAccessEdit extends Vue {

  
  @Prop({ default: () => [],  type: Array}) startGroupIdList!: string[];
  @Prop({ default: {},  type: Object}) info!: Info;

  searchTerm:string = '';
  matchList:SearchItem[] = [];
  
  groupIdList:string[] = [];

  mounted() {
    // we copy over 
    this.groupIdList = this.startGroupIdList.concat();
  }

  handleNewSearchTerm() {

    if(this.searchTerm.length < 2) {
      this.matchList = [];
      return;
    }

    this.matchList = this.searchList.filter((searchItem) => {
      
      if(this.groupIdList.includes(searchItem.groupId))
        return false;
      
      return searchItem.entId.toLowerCase().includes(this.searchTerm.toLowerCase()) || searchItem.subgroupId.toLowerCase().includes(this.searchTerm.toLowerCase());
      
    })
    
  }

  addEntry(item:SearchItem) {
    this.groupIdList.push(item.groupId);

    this.matchList = [];
    this.searchTerm = '';

    this.$emit('update', this.groupIdList.concat());
  }

  removeEntry(remGroupId:string) {

    this.groupIdList = this.groupIdList.filter((groupId) => groupId !== remGroupId);

    this.matchList = [];
    this.searchTerm = '';

    this.$emit('update', this.groupIdList.concat());
  }

  get searchList():Array<SearchItem> {

    let retList:Array<SearchItem> = [];

    return this.info.fullGroupIdList.map((groupId) => ({
      groupId: groupId,
      entId: this.extractEnterprise(groupId),
      subgroupId: groupId.split('.').pop() as string
    }));
  }

  get noAccess():boolean {
    return this.groupIdList.length === 0;
  }

  get showNoMatch():boolean {
    return this.searchTerm.length > 2 && this.matchList.length === 0;
  }

  get showMatches():boolean {
    return this.matchList.length > 0;
  }

  extractEnterprise(groupId:string):string {
    let groupList = groupId.split('.');
    return groupList.length === 2 ? groupList[0] : groupId.split('.').slice(1, -1).join(' > ');
  }

  extractSubgroup(groupId:string):string {

    let subgroupId = groupId.split('.').reverse()[0] as string;
    return subgroupId === 'master' ? 'full' : subgroupId
  }

  isMasterGroup(groupId:string):boolean {

    let subgroupId = groupId.split('.').reverse()[0] as string;
    return subgroupId === 'master';
  }

}

interface SearchItem {
  groupId:string; 
  entId:string; 
  subgroupId:string;
}
